module.exports = __webpack_public_path__ + "img/2_8_1.534cb778.jpg";